// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"12fe8de4","116":"559aa33d","177":"cc2d98ff","273":"a11251df","427":"4ec00190","580":"7b17290f","629":"845544f8","664":"018745b1","752":"f059f05c","915":"b706994f"}[chunkId] + ".chunk.js";
};